import { render, staticRenderFns } from "./InformacionGeneral.vue?vue&type=template&id=794e136a&"
import script from "./InformacionGeneral.vue?vue&type=script&lang=ts&"
export * from "./InformacionGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('794e136a', component.options)
    } else {
      api.reload('794e136a', component.options)
    }
    module.hot.accept("./InformacionGeneral.vue?vue&type=template&id=794e136a&", function () {
      api.rerender('794e136a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/VerificacionBajaCliente/Editar/InformacionGeneral.vue"
export default component.exports